import { Link } from 'react-router-dom';

const allArticles = [
  {
    title: 'What is ACBuySpreadsheet? Complete Beginner Guide',
    slug: '/article/what-is-acbuyspreadsheet',
    category: 'Beginner Guide',
    image: 'https://readdy.ai/api/search-image?query=Modern%20desk%20workspace%20with%20ultrawide%20monitor%20displaying%20spreadsheet%20dashboard%2C%20notebook%20and%20neatly%20folded%20sage%20green%20hoodie%20beside%20laptop%2C%20bright%20natural%20window%20light%20from%20right%20side%2C%20clean%20contemporary%20aesthetic%2C%20warm%20medium%20wood%20desk%20surface%2C%20productive%20atmosphere&width=800&height=600&seq=card-guide-01&orientation=landscape',
  },
  {
    title: 'ACBuySpreadsheet vs Google Sheets: Full Comparison',
    slug: '/article/acbuyspreadsheet-vs-google-sheets',
    category: 'Comparison Guide',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20workspace%20with%20two%20laptops%20side%20by%20side%20on%20dark%20walnut%20desk%2C%20one%20showing%20colorful%20spreadsheet%20the%20other%20showing%20minimalist%20dashboard%2C%20coffee%20cup%20between%20them%2C%20warm%20morning%20sunlight%20streaming%20through%20window%2C%20professional%20comparison%20setup&width=800&height=600&seq=card-compare-02&orientation=landscape',
  },
  {
    title: 'How ACBuySpreadsheet Increases Your Profit by 30%',
    slug: '/article/acbuyspreadsheet-profit-boost',
    category: 'Business Strategy',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20typing%20on%20silver%20laptop%20with%20profit%20chart%20trending%20upward%20on%20screen%2C%20fashion%20accessories%20and%20leather%20goods%20arranged%20on%20light%20grey%20desk%20surface%2C%20warm%20diffused%20studio%20lighting%2C%20business%20growth%20concept%2C%20shallow%20depth%20of%20field%2C%20premium%20feel&width=800&height=600&seq=card-profit-03&orientation=landscape',
  },
  {
    title: 'Advanced ACBuySpreadsheet Automation System',
    slug: '/article/acbuyspreadsheet-automation',
    category: 'Automation',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20desk%20setup%20with%20glowing%20translucent%20interface%20hologram%20concept%2C%20mechanical%20keyboard%20and%20neatly%20arranged%20tech%20accessories%20on%20dark%20matte%20surface%2C%20cool%20ambient%20lighting%2C%20cyberpunk%20minimal%20aesthetic%2C%20technology%20automation%20theme&width=800&height=600&seq=card-auto-04&orientation=landscape',
  },
  {
    title: 'ACBuySpreadsheet Tutorial: Step-by-Step Setup',
    slug: '/article/acbuyspreadsheet-setup-tutorial',
    category: 'Tutorial',
    image: 'https://readdy.ai/api/search-image?query=Overhead%20flatlay%20of%20person%20hands%20writing%20in%20notebook%20beside%20open%20laptop%20showing%20setup%20wizard%20interface%2C%20colorful%20sticky%20notes%20and%20pens%20arranged%20around%2C%20light%20wooden%20desk%20surface%2C%20bright%20natural%20overhead%20lighting%2C%20tutorial%20learning%20concept%2C%20organized%20creative%20workspace&width=800&height=600&seq=card-tutorial-05&orientation=landscape',
  },
  {
    title: 'Best ACBuySpreadsheet Templates for Scaling',
    slug: '/article/acbuyspreadsheet-templates',
    category: 'Templates',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20tablet%20screens%20arranged%20in%20fan%20pattern%20on%20dark%20grey%20slate%20surface%2C%20each%20showing%20different%20colorful%20spreadsheet%20dashboard%20layouts%2C%20soft%20diffused%20studio%20lighting%2C%20clean%20symmetrical%20composition%2C%20modern%20tech%20presentation%20aesthetic%2C%20template%20showcase&width=800&height=600&seq=card-templates-06&orientation=landscape',
  },
  {
    title: 'How to Use ACBuySpreadsheet for Fast Order Tracking',
    slug: '/article/acbuyspreadsheet-order-tracking',
    category: 'Order Management',
    image: 'https://readdy.ai/api/search-image?query=Warehouse%20style%20workspace%20with%20barcode%20scanner%20beside%20laptop%20showing%20order%20tracking%20interface%2C%20shipping%20labels%20and%20neatly%20packed%20boxes%20in%20background%2C%20warm%20industrial%20lighting%2C%20efficient%20logistics%20atmosphere%2C%20clean%20organized%20fulfillment%20station&width=800&height=600&seq=card-tracking-07&orientation=landscape',
  },
  {
    title: 'Top 10 ACBuySpreadsheet Tips for Resellers',
    slug: '/article/acbuyspreadsheet-reseller-tips',
    category: 'Tips & Tricks',
    image: 'https://readdy.ai/api/search-image?query=Numbered%20sticky%20notes%20arranged%20in%20arc%20pattern%20on%20light%20cork%20board%20surface%2C%20each%20with%20handwritten%20tip%2C%20small%20fashion%20accessories%20scattered%20decoratively%20around%2C%20warm%20afternoon%20sunlight%2C%20creative%20brainstorming%20aesthetic%2C%20organized%20inspiration%20board&width=800&height=600&seq=card-tips-08&orientation=landscape',
  },
  {
    title: 'ACBuySpreadsheet Cost Analysis & ROI Breakdown',
    slug: '/article/acbuyspreadsheet-cost-analysis',
    category: 'ROI Analysis',
    image: 'https://readdy.ai/api/search-image?query=Calculator%20and%20financial%20charts%20spread%20on%20light%20grey%20desk%20beside%20laptop%20showing%20ROI%20dashboard%2C%20fashion%20product%20samples%20in%20soft%20focus%20background%2C%20warm%20diffused%20office%20lighting%2C%20business%20finance%20aesthetic%2C%20clean%20professional%20composition&width=800&height=600&seq=card-roi-09&orientation=landscape',
  },
  {
    title: 'Complete ACBuySpreadsheet Workflow Optimization',
    slug: '/article/acbuyspreadsheet-workflow',
    category: 'Workflow',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20desk%20with%20large%20monitor%20showing%20workflow%20diagram%2C%20mechanical%20keyboard%20and%20neatly%20organized%20stationery%20on%20light%20concrete%20surface%2C%20soft%20ambient%20glow%2C%20clean%20tech%20workspace%2C%20efficient%20process%20management%20aesthetic&width=800&height=600&seq=card-workflow-10&orientation=landscape',
  },
  {
    title: 'ACBuySpreadsheet Safety & Data Security Guide',
    slug: '/article/acbuyspreadsheet-safety',
    category: 'Security',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20with%20laptop%20showing%20security%20lock%20icon%2C%20small%20potted%20plant%20and%20neatly%20folded%20charcoal%20sweater%20beside%20it%2C%20soft%20natural%20window%20light%2C%20calm%20secure%20workspace%20atmosphere%2C%20data%20protection%20concept%2C%20minimal%20aesthetic&width=800&height=600&seq=card-safety-11&orientation=landscape',
  },
  {
    title: 'ACBuySpreadsheet Category Shopping Strategy',
    slug: '/article/acbuyspreadsheet-category-guide',
    category: 'Shopping Strategy',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20organized%20retail%20display%20with%20neatly%20arranged%20fashion%20items%20by%20category%20on%20light%20wood%20shelving%2C%20warm%20boutique%20lighting%2C%20curated%20shopping%20aesthetic%2C%20clean%20modern%20store%20atmosphere%2C%20product%20categorization%20concept%2C%20lifestyle%20retail%20photography&width=800&height=600&seq=card-category-12&orientation=landscape',
  },
];

export default function ArticleResources() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-4">
          <span className="inline-block text-xs font-semibold text-accent-700 uppercase tracking-wider bg-accent-100/80 px-3 py-1 rounded-full">
            SEO Resources
          </span>
        </div>
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 text-center">
          ACBuySpreadsheet Resources &amp; Guides
        </h2>
        <p className="mt-3 text-sm text-foreground-500 text-center max-w-xl mx-auto">
          Comprehensive guides covering everything from beginner setup to advanced automation strategies
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {allArticles.map((article, idx) => (
            <Link
              key={idx}
              to={article.slug}
              className="group relative rounded-lg overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={article.image}
                alt={article.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-black/15"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-end text-center p-5 pb-6">
                <span className="text-xs font-semibold text-accent-300 uppercase tracking-wider mb-2">
                  {article.category}
                </span>
                <h3 className="text-sm md:text-base font-heading font-semibold text-white leading-snug line-clamp-2">
                  {article.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}